module.exports = "/_next/static/images/loading_14-643cd9728610ad90681805d60a335a3c.png";